module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/surveys/cut/hamburger-menu/hamburger-menu-icon.component.less
// module id = ./src/app/routes/surveys/cut/hamburger-menu/hamburger-menu-icon.component.less
// module chunks = main